import { NavLink } from "react-router-dom";

const RowLeader = ({index,data}) =>
{
    return(
        <tr>
            <td>{index}</td>
            <td><figure className="avatar"> <img src={data.image} alt={data.name}/> </figure></td>
            <td>{data.name}</td>
            <td>{data.email}</td>
            <td>+{data?.countryCode} {data.mobile}</td>
            <td><div className={`badge ${data.status==='Active' ? 'badge-success' :'badge-danger'}`}>{data.status}</div></td>
            <td>
                <div className="team-avatar-stack">
                    {data.team && data.team.length > 0 ? (
                        data.team.map((team, idx) => (
                            <NavLink 
                                key={idx}
                                to={`/team/${team._id}`} 
                                className="team-avatar-item"
                                data-tooltip={team?.name}
                                data-index={idx}
                                style={{zIndex: data.team.length - idx}}
                            >
                                <img 
                                    src={team.image} 
                                    className="avatar avatar-sm"
                                    alt={team.name}
                                />
                            </NavLink>
                        ))
                    ) : (
                        <div className="team-avatar-item team-avatar-empty" data-tooltip="No Team">
                            <img 
                                src="/assets/icons/team.png" 
                                className="avatar avatar-sm"
                                alt="No Team" 
                                data-tooltip="No Team"
                            />
                        </div>
                    )}
                </div>
            </td>
            <td><NavLink to={`/employee/${data.id}`} className="btn btn-secondary">Detail</NavLink></td>
        </tr>
    );
}

export default RowLeader;